import Employee from "models/employee"
import { JobTitle, Department } from "models/org-chart-node"
import EmptyState from "Components/organisms/empty-state"

interface ProfileOverviewwHeaderProps {
    jobTitle: JobTitle | null
    department: Department | null
    employee: Employee | null
    isEditing: boolean
    willingToRelocate: boolean
    onEdit: () => void
    onSave: () => void
    onCancel: () => void
    onChangeWillingToRelocate: (value: boolean) => void
}

const ProfileOverviewwHeader = ({
    jobTitle,
    department,
    employee,
    isEditing,
    willingToRelocate,
    onChangeWillingToRelocate
}: ProfileOverviewwHeaderProps) => {
    const resolvedJobTitle = jobTitle ?? employee?.jobTitle ?? null
    const resolvedDepartment = department ?? employee?.department ?? null

    return (
        <div className="overview-header">
            {
                !employee ? (
                    <EmptyState
                        title={"Something went wrong"}
                        subtitle={"We misplaced the project binder. Again. Our Bad."}
                    />
                ) : (
                    <>
                        <h2>{`${employee.commonName ?? employee.firstName} ${employee.lastName}`}</h2>

                        <div className="overview-header-grid">

                            <div>
                                <label>Title:</label>
                                <div>{resolvedJobTitle?.description ?? "-"}</div>
                            </div>

                            <div>
                                <label>Department:</label>
                                <div>{resolvedDepartment?.description ?? "-"}</div>
                            </div>

                            <div>
                                <label>Employee Code:</label>
                                <div>{employee.employeeCode ?? "-"}</div>
                            </div>

                            <div>
                                <label>Employee Type:</label>
                                <div>{employee.employeeType?.name ?? "-"}</div>
                            </div>

                            <div>
                                <label>Billable:</label>
                                <div>{employee.billability ? "Yes" : "No"}</div>
                            </div>

                            <div>
                                <label>Manager:</label>
                                <div>
                                    {employee.manager
                                        ? `${employee.manager.commonName ?? employee.manager.firstName} ${employee.manager.lastName}`
                                        : "-"}
                                </div>
                            </div>

                            <div>
                                <label>Office Location:</label>
                                <div>{employee.location?.description ?? "-"}</div>
                            </div>

                            <div>
                                <label>Phone:</label>
                                <div>{employee.phoneNumber ?? "-"}</div>
                            </div>

                            <div>
                                <label>Email:</label>
                                <div>{employee.companyEmail ?? "-"}</div>
                            </div>

                            <div>
                                <label>Hire Date:</label>
                                <div>{employee.hireDate ? new Date(employee.hireDate).toLocaleDateString() : "-"}</div>
                            </div>

                            <div>
                                <label>Will to Relocate:</label>
                                {
                                    isEditing ? (
                                        <select
                                            className="input"
                                            value={willingToRelocate ? "yes" : "no"}
                                            onChange={(e) => onChangeWillingToRelocate(e.target.value === "yes")}
                                        >
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </select>
                                    ) : (
                                        <div>{willingToRelocate ? "Yes" : "No"}</div>
                                    )
                                }
                            </div>

                        </div>
                    </>
                )
            }
        </div>
    );
};

export default ProfileOverviewwHeader